import * as React from 'react';
import {
  useQuery,
  useMutation,
  useIsFetching,
  useQueryClient,
} from 'react-query';
import useFetch from 'react-fetch-hook';
import { useIsFocused } from '@react-navigation/native';
import * as GlobalVariables from '../config/GlobalVariableContext';

export const getCountryGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Country}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetCountryGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Country}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetCountryGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Country}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const getRockGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Rock}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetRockGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Rock}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetRockGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Rock}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const getEasyGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Easy}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetEasyGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Easy}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetEasyGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Easy}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const getFolkGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Folk}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetFolkGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Folk}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetFolkGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Folk}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const getNoBarChordsGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={nobarchords}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetNoBarChordsGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={nobarchords}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetNoBarChordsGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={nobarchords}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const get2ChordSongsGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={2chordsong}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGet2ChordSongsGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={2chordsong}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGet2ChordSongsGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={2chordsong}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const getChristmasGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Christmas}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetChristmasGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Christmas}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetChristmasGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Christmas}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const getPopGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Pop}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetPopGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Pop}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetPopGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Pop}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const sINGLE$GET$GET = (Constants, { id }) =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/playiitsheet/${id || ''}`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useSINGLE$GET$GET = ({ id }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/playiitsheet/${id || ''}`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchSINGLE$GET$GET = ({ children, onData = () => {}, id }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/playiitsheet/${id || ''}`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const fetchSelectedRecordsGET = (Constants, { SearchCriteria }) =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula=FIND(LOWER('${
      SearchCriteria || ''
    }'),{BIABSearch})`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useFetchSelectedRecordsGET = ({ SearchCriteria }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula=FIND(LOWER('${
      SearchCriteria || ''
    }'),{BIABSearch})`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchFetchSelectedRecordsGET = ({
  children,
  onData = () => {},
  SearchCriteria,
}) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula=FIND(LOWER('${
      SearchCriteria || ''
    }'),{BIABSearch})`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const getFeaturedGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={featured}="BIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetFeaturedGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={featured}="BIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetFeaturedGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={featured}="BIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const fetchAllRecordsGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=desc&sort[0][field]=SortDate&filterByFormula={InBIABapp}="BIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useFetchAllRecordsGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=desc&sort[0][field]=SortDate&filterByFormula={InBIABapp}="BIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchFetchAllRecordsGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=desc&sort[0][field]=SortDate&filterByFormula={InBIABapp}="BIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const get4ChordSongsGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={4chordsong}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGet4ChordSongsGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={4chordsong}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGet4ChordSongsGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={4chordsong}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const get3ChordSongsGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={3chordsong}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGet3ChordSongsGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={3chordsong}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGet3ChordSongsGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={3chordsong}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const getNoCapoGET = Constants =>
  fetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Capoapp}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
    }
  )
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetNoCapoGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Capoapp}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetNoCapoGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/Playiitsheet?sort[0][direction]=asc&sort[0][field]=SortField&filterByFormula={Capoapp}="YesBIAB"`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};

export const getImagesGET = Constants =>
  fetch(`https://api.airtable.com/v0/appSQgowhzzXOdFQv/playiitsheet`, {
    headers: {
      Accept: 'application/json',
      Authorization: Constants['BIAB'],
      'Content-Type': 'application/json',
    },
  })
    .then(res => {
      if (!res.ok) {
        console.error('Fetch error: ' + res.status + ' ' + res.statusText);
      }
      return res;
    })
    .then(res => res.json());

export const useGetImagesGET = () => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  return useFetch(
    `https://api.airtable.com/v0/appSQgowhzzXOdFQv/playiitsheet`,
    {
      headers: {
        Accept: 'application/json',
        Authorization: Constants['BIAB'],
        'Content-Type': 'application/json',
      },
      depends: [isFocused],
    }
  );
};

export const FetchGetImagesGET = ({ children, onData = () => {} }) => {
  const Constants = GlobalVariables.useValues();
  const isFocused = useIsFocused();

  const {
    isLoading: loading,
    data,
    error,
  } = useFetch(`https://api.airtable.com/v0/appSQgowhzzXOdFQv/playiitsheet`, {
    headers: {
      Accept: 'application/json',
      Authorization: Constants['BIAB'],
      'Content-Type': 'application/json',
    },
    depends: [isFocused],
  });

  React.useEffect(() => {
    if (error) {
      console.error('Fetch error: ' + error.status + ' ' + error.statusText);
      console.error(error);
    }
  }, [error]);
  React.useEffect(() => {
    if (data) {
      onData(data);
    }
  }, [data]);

  return children({ loading, data, error });
};
